import { api } from "@/features/utils/fetch-server";
import type { ListRemindersOptions, Reminder } from "../types";

export class RemindersAPI {
  static async list(clientId: string, options?: ListRemindersOptions) {
    const params = new URLSearchParams();
    if (options?.customer_id) params.append("customer_id", options.customer_id);
    if (options?.from !== undefined)
      params.append("from", options.from.toString());
    if (options?.to !== undefined) params.append("to", options.to.toString());
    if (options?.status?.length)
      params.append("status", options.status.join(","));
    if (options?.limit) params.append("limit", options.limit.toString());

    const queryString = params.toString();
    const response = await api.get<{ reminders: Reminder[] }>(
      `/api/sessions/v1/${clientId}/reminders${
        queryString ? `?${queryString}` : ""
      }`,
    );
    return response.reminders;
  }

  static async cancel(clientId: string, reminderId: string) {
    const response = await api.delete<{ success: boolean }>(
      `/api/sessions/v1/${clientId}/reminders/${reminderId}`,
    );
    return response.success;
  }
}
